// react
import React, { Fragment, useState, useEffect } from "react";
// store
import { paymentService } from "../../../../store/services/ServicePayment";
import { LOADING_TIME } from "../../../../store/config";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import OrderedEventsTable from "./OrderedEventsTable";
import { Card, Form, Button, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";

// component
const OrderedEvents = () => {

    // eslint-disable-next-line
    const [data, setData] = useState([]);
    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY"),
        status: null,
        activity: null
    })

    const [activityOptions, setActivityOptions] = useState([])

    const [stats, setStats] = useState({
        total: 0,
        used: 0,
        nonUsed: 0,
        refunded: 0,
    })

    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // fetch data
    async function fetchData() {
        setIsLoading(true);
        let params = `?from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`;
        
        if( filters.status !== null ){
            params += `${filters.status}`
        }
        
        const result = await paymentService.getDigitalProductsForProvider(params);

        if (result.status === 200) {
            // calculate stats
            const orders = result.response
            orders.sort(function(a, b) {
                if (!a.event || !a.event.starts) return 1;
                if (!b.event || !b.event.starts) return -1;
                let c = new Date(a.event.starts);
                let d = new Date(b.event.starts);
                return d - c;
            });

            let totalRefunded = 0;
            let totalUsed = 0;
            let totalNonUsed = 0;
            let options = [];
            let all = orders.length;
            for(let i = 0; i < orders.length; i++) {
                if (!orders[i].event) {
                    orders[i] = {...orders[i], show: false};
                    all -= 1;
                    continue;
                }
                // create activity list:
                if( !options.some(item => item.value === orders[i].event.activity.id) ){
                    options.push({
                        id: orders[i].event.activity.id,
                        value: orders[i].event.activity.id,
                        text: orders[i].event.activity.name
                    })
                }

                if( (filters.activity === orders[i].event.activity.id || filters.activity === null) ){
                    orders[i] = {...orders[i], show: true};
                    if( orders[i].is_used ) {
                        totalUsed += 1
                    } else {
                        totalNonUsed += 1
                    }
                    
                    if( orders[i].is_refunded ){
                        totalRefunded += 1
                    }
                } else {
                    orders[i] = {...orders[i], show: false};
                    all -= 1;
                }
                
            }

            setData(orders);
            setActivityOptions(options)
            setStats({
                total: all,
                used: totalUsed,
                nonUsed: totalNonUsed,
                refunded: totalRefunded,
            })
        }

        setTimeout(function () {
            setIsLoading(false);
        }, LOADING_TIME);
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleFilter = async () => {
        await fetchData()
        if (isMobile) {
            setShowFilters(false)
        }
    }

    const statusOptions = [
        { key: 2, text: 'Nevyužité', value: '&is_used=false' },
        { key: 3, text: 'Využité', value: '&is_used=true&is_refunded=false' },
        { key: 4, text: 'Zrušená/vrátená', value: '&is_refunded=true' },
    ]

    // template
    return (
        <Fragment>
            <HeaderTitle title="Prehľad objednávok" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div 
                            onClick={() => setShowFilters(!showFilters)}
                            style={{ 
                                display: "flex", 
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem", 
                                background: "#f8f9fa", 
                                border: "1px solid #e0e0e0", 
                                borderRadius: "8px", 
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}
                
                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem" }}>
                            <Form onSubmit={handleFilter}>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr) repeat(2, 1fr) auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({...filters, from: value})}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({...filters, to: value})}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Stav
                                        </label>
                                        <Form.Select
                                            fluid
                                            clearable
                                            options={statusOptions}
                                            placeholder='Vyberte stav'
                                            value={ filters.status }
                                            onChange={(e, { value }) => setFilters({...filters, status: value})}
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Aktivita
                                        </label>
                                        <Form.Select
                                            fluid
                                            search
                                            clearable
                                            options={activityOptions}
                                            placeholder='Vyberte aktivitu'
                                            value={ filters.activity }
                                            onChange={(e, { value }) => {
                                                if( value === "" ) setFilters({...filters, activity: null})
                                                if( value !== "" ) setFilters({...filters, activity: value})
                                            }}
                                        />
                                    </Form.Field>
                                    <Button 
                                        fluid 
                                        type="submit"
                                        style={{ 
                                            background: "var(--primary)", 
                                            color: "#fff", 
                                            borderRadius: "6px", 
                                            fontWeight: 600, 
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}

                { isLoading 
                    ? <Loading />
                    : 
                    <>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : "repeat(4, 1fr)",
                                gap: isMobile ? "0.6rem" : "0.85rem",
                                marginBottom: "1rem"
                            }}
                        >
                            <div style={{ 
                                borderRadius: "8px", 
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem", 
                                border: "1px solid #e0e0e0", 
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Celkovo</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#333", lineHeight: 1 }}>{ stats.total }</div>
                                </div>
                            </div>
                            <div style={{ 
                                borderRadius: "8px", 
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem", 
                                border: "1px solid #e0e0e0", 
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Využité</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#00a651", lineHeight: 1 }}>{ stats.used }</div>
                                </div>
                            </div>
                            <div style={{ 
                                borderRadius: "8px", 
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem", 
                                border: "1px solid #e0e0e0", 
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Nevyužité</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#f2711c", lineHeight: 1 }}>{ stats.nonUsed }</div>
                                </div>
                            </div>
                            <div style={{ 
                                borderRadius: "8px", 
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem", 
                                border: "1px solid #e0e0e0", 
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Zrušené</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#db2828", lineHeight: 1 }}>{ stats.refunded }</div>
                                </div>
                            </div>
                        </div>
                        <OrderedEventsTable orders={data} setOrders={setData} isLoading={isLoading} />
                    </>
                }
            </section>
        </Fragment>
    );
};

export default OrderedEvents;
